var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import Popup from '../../../components/Popup';
import CurrencyFormatter from '../../../core/utils/currency-formatter';
import { t } from '../../../core/utils/translation-helper';
import { validateCoupon } from '../../Coupon/store/actions';
var mapStateToProps = function (state) { return ({
    coupon: state.coupon,
}); };
var mapDispatchToProps = {
    validateCoupon: validateCoupon,
};
var connector = connect(mapStateToProps, mapDispatchToProps);
var CouponForm = /** @class */ (function (_super) {
    __extends(CouponForm, _super);
    function CouponForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isDetailsOpen: false,
            coupon: '',
            isLoading: false,
            isOpen: false,
            isError: false,
        };
        return _this;
    }
    CouponForm.prototype.render = function () {
        if ('loading' === this.props.coupon.status) {
            return null;
        }
        var classList = ['c-coupon-form'];
        if ('loaded' === this.props.coupon.status) {
            classList.push('c-coupon-form--loaded');
        }
        return (React.createElement(React.Fragment, null,
            this.renderPopup(),
            React.createElement("div", { className: classList.join(' ') },
                React.createElement("div", { className: "c-coupon-form__header" }, this.renderCouponFormHeader()),
                this.renderCouponFormBottom())));
    };
    CouponForm.prototype.renderPopup = function () {
        var _this = this;
        if (!this.props.coupon.item) {
            return null;
        }
        if (!this.state.isDetailsOpen) {
            return null;
        }
        return (React.createElement(Popup, null,
            React.createElement("div", { className: "h-text--center" },
                React.createElement("h1", { className: "c-title c-title--style2" }, this.props.t('cart.coupon.details.title')),
                React.createElement("div", { style: { whiteSpace: 'pre-wrap' } }, t('description', this.props.coupon.item.coupon.translations)),
                React.createElement("button", { className: "c-btn c-btn--ghost h-margin-top--30", onClick: function () { return _this.toggleDetails(); } }, this.props.t('cart.coupon.details.close')))));
    };
    CouponForm.prototype.renderCouponFormHeader = function () {
        var _this = this;
        if ('loaded' === this.props.coupon.status && this.props.coupon.item) {
            var doConditionsMatch = this.props.coupon.item.do_conditions_match;
            return (React.createElement(React.Fragment, null,
                React.createElement("h2", null,
                    React.createElement("i", { className: "icon-coupon" }),
                    doConditionsMatch && React.createElement("i", { className: "icon-checkmark-circle" }),
                    !doConditionsMatch && React.createElement("i", { className: "icon-exclamation-circle" }),
                    this.props.t(doConditionsMatch ? 'cart.coupon.title.active' : 'cart.coupon.title.mismatch_conditions', { coupon: this.props.coupon.item.code }),
                    doConditionsMatch && (React.createElement("span", null, CurrencyFormatter.format(this.props.coupon.item.discount_amount * -1)))),
                React.createElement("div", { className: "c-coupon-form__header__details", onClick: function () { return _this.toggleDetails(); } }, this.props.t('cart.coupon.details.link'))));
        }
        return (React.createElement("h2", { onClick: function () { return _this.setState({ isOpen: !_this.state.isOpen }); } },
            React.createElement("i", { className: "icon-coupon" }),
            React.createElement("a", null, this.props.t('cart.coupon.title.inactive'))));
    };
    CouponForm.prototype.renderCouponFormBottom = function () {
        var _this = this;
        if (!this.state.isOpen || 'loaded' === this.props.coupon.status) {
            return false;
        }
        return (React.createElement("div", { className: "c-coupon-form__bottom" },
            React.createElement("div", { className: "c-coupon-form__bottom__form" },
                React.createElement("div", { className: "c-form-element h-padding-top--5" },
                    React.createElement("label", { htmlFor: "promo-code-input", className: "c-form-element__label" }, this.props.t('cart.coupon.input.label')),
                    React.createElement("input", { type: "text", className: "c-form-element__input c-input c-input--text", id: "promo-code-input", onChange: function (e) { return _this.setState({ coupon: e.target.value }); }, onKeyUp: function (e) {
                            if ('Enter' === e.key) {
                                _this.handleSubmit();
                            }
                        } }),
                    'error' === this.props.coupon.status && (React.createElement("div", { className: "c-form-element__error" }, this.props.t('cart.coupon.input.error')))),
                React.createElement("button", { onClick: function () { return _this.handleSubmit(); }, disabled: this.state.isLoading }, this.props.t('cart.coupon.button')))));
    };
    CouponForm.prototype.toggleDetails = function () {
        this.setState({ isDetailsOpen: !this.state.isDetailsOpen });
    };
    CouponForm.prototype.handleSubmit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.state.coupon || this.state.isLoading) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.setState({ isLoading: true })];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.props.validateCoupon(this.state.coupon)];
                    case 2:
                        response = _a.sent();
                        if (response) {
                            if (localStorage) {
                                localStorage.setItem('coupon', response.code);
                            }
                        }
                        return [4 /*yield*/, this.setState({ isLoading: false })];
                    case 3:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    return CouponForm;
}(React.Component));
export default connector(withTranslation()(CouponForm));
